import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback for cross-domain cookie issues
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatErr(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Erreur inconnue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" · ");
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}
